const Resources = {

    table_headers: [
        { 
            text:  'Description',
            value: 'custom_description',
        },
        { 
            text:  'Frequency',
            value: 'frequency',
        },
        { 
            text:  'Room Type',
            value: 'room_type_description'
        },
        { 
            text:  'Task',
            value: 'task',
        },
        { 
            text:  'Last Completed',
            value: 'last_completed',
        },
        { 
            text:  'Next Scheduled',
            value: 'next_scheduled',
        },
        { 
            text:  'Minutes',
            value: 'minutes',
        },
    ],

    table_headers_projects: [
        {   
            text: 'Number',
            value: 'number',
            type:   "link",
            style: "bold",
        },
        { 
          text: 'Description',
          align: 'start',
          value: 'description',
          type:   "link",
          style: "bold",
        },
        { 
            text: 'Minutes',
            value: 'minutes'
        },
        { 
            text: 'Associate',
            value: 'associate'
        },
    ],

    employee_table_headers_projects: [
        {   
            text: 'Number',
            value: 'number',
            style: "bold",
        },
        { 
          text: 'Description',
          align: 'start',
          value: 'description',
          type:   "link",
          style: "bold",
        },
        { 
            text: 'Minutes',
            value: 'minutes'
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Assignments',
            href:   '/assignment-daily-assignments',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Projects',
            href:   '/assignment-projects',
            arrow:  "<span class='slash'>/</span>",
        },
        // {
        //     name:   'Project Scheduler',
        //     href:   '/assignment-projects-scheduler',
        //     arrow:  "<span class='slash'>/</span>",
        // },
        {
            name:   'Scheduled Rooms',
            href:   '/assignment-projects-scheduled-rooms',
            arrow:  "",
        },
    ],

    inactive_rooms_options: [
        {
            id: '',
            name: 'All',
        },
        {
            id: 1,
            name: '30 days',
        },
        {
            id: 2,
            name: '60 days',
        },
        {
            id: 3,
            name: '90 days',
        },
    ],

    next_scheduled_options: [
        {
            id: '',
            name: 'All',
            value: 0,
        },
        {
            id: 1,
            name: '7 days',
            value: 7,
        },
        {
            id: 1,
            name: '30 days',
            value: 30,
        },
        {
            id: 2,
            name: '60 days',
            value: 60,
        },
        {
            id: 3,
            name: '90 days',
            value: 90,
        },
    ],
    
    default_filters: [{key: 'radio', value: 'projects'}],

    
    filter_options:
    {
        show_properly_assigned_rooms: false,
        show_rooms_that_are: false,
        daily: false,
        policing: false,
        projects: false,
    },


}

export default Resources;